import { CertificateTemplate } from '../../../../interface';

export interface CertificateTemplateMeta {
  value: CertificateTemplate;
  label: string;
  shortLabel: string;
  description: string;
}

export const CERTIFICATE_TEMPLATES: CertificateTemplateMeta[] = [
  {
    value: CertificateTemplate.CERT_TEMPLATE_1,
    label: 'Academy Classic',
    shortLabel: 'Template 1',
    description: 'Two-page classic certificate.',
  },
  {
    value: CertificateTemplate.CERT_TEMPLATE_2,
    label: 'Excellence Gradient',
    shortLabel: 'Template 2',
    description: 'A bold modern certificate with a premium gradient backdrop and a strong hero presentation.',
  },
  {
    value: CertificateTemplate.CERT_TEMPLATE_3,
    label: 'Minimal Ledger',
    shortLabel: 'Template 3',
    description: 'A clean editorial certificate focused on readability, credential ID visibility, and QR verification.',
  },
];

export const getCertificateTemplateMeta = (template?: CertificateTemplate | null) => (
  CERTIFICATE_TEMPLATES.find((item) => item.value === template) ?? CERTIFICATE_TEMPLATES[0]
);
